import { Alert, Button, Space } from 'antd';
import { ApiError } from '../api/client';

interface ErrorAlertProps {
  error: unknown;
  onRetry?: () => void;
  title?: string;
}

/** 统一的错误展示：区分 ApiError 与未知错误，并提供重试入口 */
export function ErrorAlert({ error, onRetry, title }: ErrorAlertProps): React.ReactElement | null {
  if (!error) {
    return null;
  }
  const message =
    error instanceof ApiError
      ? `${error.message}${error.code ? `（${error.code}）` : ''}`
      : error instanceof Error
        ? error.message
        : '请求失败';
  const requestId = error instanceof ApiError ? error.requestId : undefined;

  return (
    <Alert
      type="error"
      showIcon
      title={title ?? '加载失败'}
      description={
        <Space orientation="vertical" size={4}>
          <span>{message}</span>
          {requestId ? <span style={{ fontSize: 12 }}>请求 ID：{requestId}</span> : null}
        </Space>
      }
      action={
        onRetry ? (
          <Button size="small" onClick={onRetry}>
            重试
          </Button>
        ) : undefined
      }
    />
  );
}

export function errorText(error: unknown): string {
  if (error instanceof ApiError) {
    return error.message;
  }
  if (error instanceof Error) {
    return error.message;
  }
  return '请求失败';
}
